<template>
  <v-footer id="dashboard-core-footer" absolute>
    <v-container>
      <v-row align="center" no-gutters>
        <v-spacer class="hidden-sm-and-down" />
        <v-col cols="12" md="auto">
          <div class="body-1 font-weight-light pt-md-0 text-center">
            &copy; 2020, made
            by
            <a href="https://www.andqxai.uz">TDAU Andijon filiali</a>.
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "DashboardCoreFooter",

  data: () => ({}),
};
</script>

<style scoped>
#dashboard-core-footer {
  margin-top: 50px !important;
}
</style>
